import React from 'react';

import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import Header from '../components/Header/Header';
import ManageCustomerAccount from './ManageCustomerAccounts/ManageCustomerAccount';

const CustomerAccount = ({ loginId, settings, match }) => {
	const hasSettings = loginId && settings;
	return (
		hasSettings && (
			<>
				<Header activeTab={3} />
				<Switch>
					<Route
						path={`${match.path}/Search`}
						component={ManageCustomerAccount}
					/>

					<Redirect path="*" to={`${match.path}/Search`} />
				</Switch>
			</>
		)
	);
};

CustomerAccount.propTypes = {
	loginId: PropTypes.string,
	settings: PropTypes.object,
	match: PropTypes.object,
};

export default injectIntl(
	connect((state) => ({
		loginId: state.getIn(['settings', 'UserLoginId']),
		settings: state.get('settings'),
	}))(CustomerAccount),
);
